import React, { useState, useRef, useEffect } from "react";
import { useLocation, useHistory } from "react-router";
import { Link } from "react-router-dom";
import { exportComponentAsPNG } from "react-component-export-image";
import logo from "../../../images/logo.svg";
import "../../../styles/career-fair-one.css";
import career from "../../../images/career-day.svg";
import UploadImgMain from "./UploadImg";
import { BaseTemplate } from "../Career-fair/CareerFair";

// IWD specific implementation using the base template
export const MemeComponent = React.forwardRef((props, ref) => {
  return (
    <BaseTemplate
      ref={ref}
      headerLogo={career}
      bottomText1="Celebrating"
      bottomText2="#InternationalWomensDay"
      footerText="STERLING INTERNATIONAL WOMEN'S DAY"
      footerLink="https://sterling.ng/iwd"
      footerLinkText="sterling.ng/iwd"
      img={props.img}
    />
  );
});

const IWD = (props) => {
  const history = useHistory();
  const memeRef = useRef();
  const location = useLocation();

  const [imgPreview, setImgPreview] = useState(null);
  const [modal, setModal] = useState("close");

  const uploadImgModal = () => {
    setModal("open");
  };
  const previewModal = () => {
    setModal("preview");
  };
  const closeModal = () => {
    setModal("close");
  };

  const imgChange = (e) => {
    if (e.target.files[0]) {
      const url = URL.createObjectURL(e.target.files[0]);
      setImgPreview(url);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      {modal === "open" && (
        <UploadImgMain closeModal={closeModal} previewModal={previewModal} />
      )}
      <div className="h-screen flex template-main">
        <div className="actions p-8">
          <Link to="/">
            <img src={logo} alt="logo" className="h-10 w-10 rounded-full" />
          </Link>
          <div className="btns my-10 space-y-4">
            <input
              type="file"
              className="hidden"
              onChange={imgChange}
              id="img"
            />
            <label className="upload" onClick={uploadImgModal}>
              Upload Photo
            </label>
            <button className="change-template" onClick={history.goBack}>
              Change Template
            </button>
          </div>
        </div>
        <div className="main p-4">
          <MemeComponent ref={memeRef} img={imgPreview} />
          <div
            className="memeBtns flex mt-4 w-full space-x-4 justify-between h-12"
            style={{ fontFamily: "Museo300" }}
          >
            <button
              className="w-full bg-green-500 rounded h-full font-bold text-white"
              onClick={uploadImgModal}
            >
              Select Photo
            </button>
            <button
              className="change-template w-full rounded h-full font-bold"
              onClick={history.goBack}
            >
              Change Template
            </button>
          </div>
          <button
            className="meme-download"
            onClick={() =>
              exportComponentAsPNG(memeRef, { fileName: "IWD" })
            }
          >
            Download Meme
          </button>
        </div>
      </div>
    </>
  );
};

export default IWD; 